<template>
  <v-main>
    <AppBar :hide-background="step1"
            :helpContent=true
            @helpContentOpen="helpContentOpen"/>

    <!-- 하단 콘텐츠 영역이 3초간 노출되었다가 사라지며...다음 컨텐츠 노출) -->
    <v-layout fill-height column class="survey-intro">
      <Transition name="fade">
        <v-container v-if="step1" fluid flex-fill class="step1">
          <v-img v-if="isSamsungFire" :src="getImage('background/intro/samsungfire/intro-bg-720-x-1516.svg')"
                 class="step1-img"/>
          <v-img v-else :src="getImage('background/intro/intro-bg-720-x-1516.svg')" class="step1-img"/>
          <div class="step1-caption">
            <b>맞춤형</b><br/>
            <b>마음 여행 코스</b>를<br/>
            추천해 드리기 위한<br/>
            <b>여행지원서</b>를 작성해 보세요
          </div>
          <div class="step1-bottom">
            이지앤웰니스에서 독자적으로 개발한 타당도와 신뢰도가 검증된
            심리검사입니다. 현재심리적 상태와 심층적 성향을 연결 지어 더
            자세히 개인을 이해하고 이를 바탕으로 솔루션을 제공할 목적으로
            제작되었습니다.
          </div>
        </v-container>
        <div v-if="step2" class="step2">
          <v-container fluid class="step2-caption">
            <p>
              <span class="primary--text">여행지원서</span>는 총 45문항으로 약 <span class="primary--text">15분</span> 정도<br/>
              소요되며 게임, 그림 등으로 다양하게<br/>
              구성되어 있어요
            </p>
            <p>
              여행지원서를 작성하는 경험 자체로<br/>
              <span class="primary--text">마음을 들여다볼 수 있는 계기가 되길 바래요</span>
            </p>
          </v-container>
          <div class="step2-images">
            <!-- 이미지 서버에서 받으옴 -->
            <div class="images">
              <Transition name="fade">
                <div v-if="img1">
                  <img :src="getImage(imgURL[0])">
                </div>
                <div v-else-if="img2">
                  <img :src="getImage(imgURL[1])">
                </div>
                <div v-else-if="img3">
                  <img :src="getImage(imgURL[2])">
                </div>
              </Transition>
            </div>
          </div>
        </div>
        <div v-if="step3" class="pos-center">
          <div class="fs-18 secondary--text">보다 정확한 결과를 위해서는,</div>
          <div class="step3-text">
            <p ref="text1">
              되도록 <b>조용하고 방해받지 않은</b><br>
              환경에서 진행해주세요.
            </p>
            <p ref="text2">
              여러 번에 나누어 하는 것보다는<br>
              <b>한 번에 완료</b>하는 것이 좋아요.
            </p>
            <p ref="text3">
              너무 오래 생각하기보다는<br>
              <b>떠오르는 대로 빠르게</b><br>
              응답해 보세요.
            </p>
          </div>
        </div>
        <div v-if="step4" class="step4">
          <v-container fluid class="step4-text">그럼, 시작해볼까요?</v-container>
          <div class="content-footer">
            <FooterBtns ok="시작하기" cancel="다음에 하기" @hide="$emit('surveyStop')" @submit="surveyStart"/>
          </div>
        </div>
      </Transition>
    </v-layout>
    <!-- 서비스 이용 동의 -->
    <BottomSheet ref="BottomSheet">
      <template #default="{ close }">
        <v-card>
          <v-card-title>
            서비스 이용 동의
            <v-spacer/>
            <v-btn icon @click="close">
              <IconClose />
            </v-btn>
          </v-card-title>
          <v-container class="py-0">
            <dl class="agreement-block">
              <dt class="agreement-chk-all">
                <v-checkbox
                    v-model="allCheck"
                    label="전체 서비스 이용 동의하기"
                    :ripple="false"
                    hide-details
                    class="checkbox-circle"
                    @change="(value) => allCheckState(value)"
                />
              </dt>
              <dd class="agreement-chk-box" v-for="(item, index) in terms" :key="index">
                <v-checkbox
                    v-model="item.value"
                    :ripple="false"
                    hide-details
                    class="checkbox-circle"
                >
                  <template #label>
                    [{{ item.required ? '필수' : '선택' }}] {{ item.label }}
                  </template>
                </v-checkbox>
                <v-spacer />
                <v-btn icon plain :ripple="false" @click="termsDetailsOpen(item.terms)">
                  <img :src="getImage('ic_arrow_right6.svg')">
                </v-btn>
              </dd>
            </dl>
          </v-container>
          <v-card-actions>
            <v-btn x-large block depressed
                   color="primary" class="btn-submit"
                   :disabled="!agreeValid"
                   @click="surveyStart('next')"
            >다음</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </BottomSheet>
    <TermsDetailsModal :dialog="termsDetailsDialog"
                       :flag="termsFlag"
                       @close="termsDetailsDialog = false"/>
    <!-- // 서비스 이용 동의 -->
    <SurveyHelpContentSheet ref="SurveyHelpContentSheet"/>
  </v-main>
</template>

<script>
import {mixinAuth} from '@/mixins'
import FooterBtns from '@/components/btns/FooterBtns'
import SurveyHelpContentSheet from '@/components/layout/bottomSheet/SurveyHelpContentSheet'
import TermsDetailsModal from '@/components/terms/TermsDetailsModal.vue'
import store from "@/store";

export default {
  components: {
    TermsDetailsModal,
    FooterBtns,
    SurveyHelpContentSheet
  },
  mixins: [mixinAuth],
  props: ["step"],
  data: () => ({
    termsDetailsDialog: false,
    termsFlag: null,
    allCheck: false,
    terms: [
      { label: '개인정보 수집 및 이용 동의', value: false, required: true, terms: 7 }, // 임시
      { label: '민감정보 수집 및 이용 동의', value: false, required: true, terms: 8 }  // 임시
    ],
    step1: false,
    step2: false,
    img1: false,
    img2: false,
    img3: false,
    step3: false,
    step4: false,
    imgURL: ['img-survey-intro-01.png', 'img-survey-intro-02.png', 'img-survey-intro-03.png'],
    timeoutId: [],
  }),
  computed: {
    agreeValid () {
      if (this.isSamsungFire) return true // 삼성화재면 동의 체크 제외
      let required = this.terms.filter(term => term.required)
      let valid = this.terms.filter(term => term.required && term.value)
      return required.length === valid.length
    }
  },
  watch: {
    terms: {
      deep: true,
      handler () {
        let all = this.terms.length
        let chk = this.terms.filter(term => term.value).length
        this.allCheck = all === chk
      }
    },
    timeoutId: {
      deep: true,
      immediate: true,
      handler: function () {
        // console.log("this.timeoutId : ", this.timeoutId)
        this.$emit("setTimeoutId", this.timeoutId)
      },
    }
  },
  mounted() {
    // console.log("this.$refs : ", this.$root.$children[0].$refs)
    // this.$root.$children[0].$refs.appBar.$el.style.display='none'
    if (this.step === 0) {
      this.step1Active()
    }
    // setTimeout(() => this.step1Active(), 1000);
    // console.log("this.timeoutId : ", this.timeoutId)
  },
  methods: {
    termsDetailsOpen(index) {
      this.termsFlag = index
      this.termsDetailsDialog = true
    },
    surveyStart(type = 'start') {
      const success = store.getters.isApplResult === 'success';
      switch (type) {
        case "start":
        case "next":
          if (success) this.$emit('surveyStart')
          else {
            if (type === "start") this.$refs.BottomSheet.open()
            else {
              store.commit("setTravelApplAgree", true);
              this.$emit('surveyStart')
            }
          }
          break;
      }
      // const success = store.getters.isApplResult === 'success';
      // switch (type) {
      //   case "start":
      //     if (success) {
      //       this.$emit('surveyStart')
      //     }
      //     else {
      //       this.$refs.BottomSheet.open()
      //     }
      //     break;
      //   case "next":
      //     if (success) {
      //       this.$emit('surveyStart')
      //     }
      //     else {
      //       store.commit("setTravelApplAgree", true);
      //       this.$emit('surveyStart')
      //     }
      //     break;
      // }
    },
    allCheckState (value) {
      this.terms = this.terms.map(term => ({
        ...term,
        value: value
      }))
    },
    helpContentOpen() {
      this.$nextTick(() => {
        this.$refs.SurveyHelpContentSheet.sheetOpen(true)
      })
    },
    step1Active() {
      this.step1 = true;
      this.timeoutId.push(setTimeout(() => {
        this.step1 = false;
        this.step1Active2();
      }, 4000))
    },
    step1Active2() {
      this.timeoutId.push(setTimeout(() => {
        this.step2 = true;
        this.img1 = true
      }, 500))
      this.timeoutId.push(setTimeout(() => this.img1 = false, 2000))
      this.timeoutId.push(setTimeout(() => this.img2 = true, 2500))
      this.timeoutId.push(setTimeout(() => this.img2 = false, 4000))
      this.timeoutId.push(setTimeout(() => this.img3 = true, 4500))
      this.timeoutId.push(setTimeout(() => {
        this.step2 = false;
        this.step1Active3()
      }, 6000))
    },
    step1Active3() {
      this.timeoutId.push(setTimeout(() => this.step3 = true, 500))
      this.timeoutId.push(setTimeout(() => this.$refs.text1.style.opacity = 1, 1500))
      this.timeoutId.push(setTimeout(() => this.$refs.text2.style.opacity = 1, 2500))
      this.timeoutId.push(setTimeout(() => this.$refs.text3.style.opacity = 1, 3500))
      this.timeoutId.push(setTimeout(() => {
        this.step3 = false;
        this.step1Active4()
      }, 5000))
    },
    step1Active4() {
      this.timeoutId.push(setTimeout(() => this.step4 = true, 500))
    },
  },
};
</script>
